<app-dialog [subtitle]="appAlert.confirmDialog.title" [hideIcon]="true" data-testid="confirm-dialog">
    <form-item-text [subtitle]="appAlert.confirmDialog.message"></form-item-text>
    <form-action-buttons [justify]="'center'">
        <form-button [subtitle]="appAlert.confirmDialog.cancelButtonText"
                     [btnType]="'cancel'"
                     (click)="appAlert.closeConfirmDialog()">
        </form-button>
        <form-button [subtitle]="appAlert.confirmDialog.okButtonText"
                     [btnType]="appAlert.confirmDialog.danger ? 'danger' : 'confirm'"
                     (click)="appAlert.confirmDialogAction()">
        </form-button>
    </form-action-buttons>
</app-dialog>
